<section class="grid gap-8 grid-cols-1 md:gap-8 md:grid-cols-2">
    <label  *ngIf="!createFamilyProfile" class="block">
    </label>
    <label  *ngIf="!createFamilyProfile"
      style="background-image: url({{guardianToSave.ImageUrl}}); width: 150px; height: 150px"
      class="bg-cover bg-center bg-no-repeat border-white rounded-full cursor-pointer flex flex-col bg-blue-200 border-2 h-48 ring-primary ring-1 w-48 group justify-end items-end">
      <input 
        [name]="'Passport'" 
        type="file" 
        class="hidden" 
        accept=".png, .jpg, .jpeg" 
        (change)="generatePreview($event)"
        [disabled]="loading"
      />
      <div class="text-primary/50 text-5xl material-icons inline-block group-hover:text-primary">
        add_a_photo
      </div>
    </label>
    
    <label *ngIf="createFamilyProfile" class="block">
        <div class="font-medium text-grey-darker text-sm pb-2">
          Family Surname *
        </div>
        <input
          type="text" 
          [name]="'Surname'" 
          placeholder="Surname"
          [(ngModel)]="guardianToSave.Surname"
          class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
        />
    </label>
    
    <label *ngIf="createFamilyProfile" class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        School Branch *
      </div>
      <select 
      [name]="'CompanyId'"
      [(ngModel)]="guardianToSave.CompanyId" 
      class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 focus:outline-none focus-within:border-primary-light">
        <option disabled value=""[selected]="guardianToSave.CompanyId == undefined">Select option</option>
        <option *ngFor="let item of companies" 
        [value]="item.Id" 
        [selected]="item.Id == guardianToSave.CompanyId">
          {{ item.Name }}
        </option>
      </select>
    </label>

    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        {{createFamilyProfile ? 'Guardian Full Name' : 'Name'}} *
      </div>
      <input
        type="text" 
        [name]="'Name'" 
        placeholder="Name"
        [(ngModel)]="guardianToSave.Name"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      />
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        Phone Number *
      </div>
      <input
        type="text" 
        [name]="'PhoneNumber'" 
        placeholder="Phone Number"
        [(ngModel)]="guardianToSave.PhoneNumber"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      />
    </label>
    
    <label *ngIf="!createFamilyProfile" class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        Relationship With Child *
      </div>
      <select 
      [name]="'RelationshipWithChild'"
      [(ngModel)]="guardianToSave.RelationshipWithChild" 
      class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 focus:outline-none focus-within:border-primary-light">
        <option disabled value=""[selected]="guardianToSave.RelationshipWithChild == undefined">Select option</option>
        <option *ngFor="let item of ChildLeavingWith" 
        [value]="item" 
        [selected]="item == guardianToSave.RelationshipWithChild">
          {{ item }}
        </option>
      </select>
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        Home Address *
      </div>
      <input
        type="text" 
        [name]="'HomeAddress'" 
        placeholder="Home Address"
        [(ngModel)]="guardianToSave.HomeAddress"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      />
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        City *
      </div>
      <input
        type="text" 
        [name]="'City'" 
        placeholder="City"
        [(ngModel)]="guardianToSave.City"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      />
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        State *
      </div>
      <select 
      [name]="'State'" 
      [(ngModel)]="guardianToSave.State"
      class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 focus:outline-none focus-within:border-primary-light">
        <option disabled value="">Select state</option>
        <option *ngFor="let state of states" [value]="state.StateID" 
        [selected]="state.StateID == guardianToSave.State">
          {{ state.Name }}
        </option>
      </select>
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        Email *
      </div>
      <input
        type="email" 
        [name]="'Email'" 
        placeholder="Email"
        [(ngModel)]="guardianToSave.Email"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      />
    </label>
    
    <label class="block">
      <div class="font-medium text-grey-darker text-sm pb-2">
        Office Address
      </div>
      <textarea
        type="text" 
        [name]="'OfficeAddress'" 
        placeholder="OfficeAddress"
        [(ngModel)]="guardianToSave.OfficeAddress"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
      ></textarea>
    </label>

</section>